var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 3.01L13.42 0L0 12L13.42 24L16 20.99L5.94 12L16 3.01Z"}));
}

ChevronLeft.defaultProps = {"width":"16","height":"24","viewBox":"0 0 16 24","fill":"currentColor"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
